// import "./App.css";
import { Routing } from "./routes/Routing";
import "./App.css";
import "./Dashboard.css";

function App() {
  return <Routing />;
}

export default App;
